<!--客户购买体验卡-->
<template>
  <div>
    <el-form ref="registerRef" label-width="120px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="手机号:">
            <el-input readonly="true" style="width: 270px" v-model="childInfo.userPhone" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="月龄:">
            <el-input readonly="true" style="width: 270px" v-model="childInfo.userPhone" placeholder=""></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="会员姓名:">
            <el-input readonly="true" style="width: 270px" v-model="childInfo.name" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="性别:" prop="gender">
            <el-select v-model="childInfo.gender" placeholder="请选择" style="width: 270px" disabled>
              <el-option v-for="item in genderOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="小名:">
            <el-input style="width: 270px" v-model="childInfo.petName" placeholder="" readonly="true"></el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="12">
          <el-form-item label="等级:" prop="level">
            <el-select v-model="childInfo.level" placeholder="请选择" style="width: 270px" disabled>
              <el-option v-for="item in [
                { label: '一级', value: 1 },
                { label: '二级', value: 2 },
                { label: '三级', value: 3 },
                { label: '四级', value: 4 },
              ]" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
      </el-row>
      <!-- <template v-if="childInfo.userBuyLevels && childInfo.userBuyLevels.length">
        <el-row v-for="(v, index) in childInfo.userBuyLevels" :key="index">
          <el-col :span="12">
            <el-form-item label="业务等级:">
              <el-select disabled v-model="v.lessonsId" placeholder="请选择" style="width: 270px">
                <el-option v-for="item in storeLessonsList" :disabled="childInfo.userBuyLevels
                  .map((mk) => {
                    return Number(mk.lessonsId);
                  })
                  .includes(item.storeLessonId)
                  ? true
                  : false
                  " :key="item.storeLessonId" :label="item.name" :value="item.storeLessonId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="display: flex;align-items: center;">
            <el-form-item label="确认等级:">
              <el-select disabled v-model="v.level" placeholder="请选择" style="width: 150px">
                <el-option v-for="item in levelOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </template> -->
      <el-row>
        <el-col :span="12">
          <el-form-item label="课时:" prop="residueCount">
            <el-input readonly="true" style="width: 270px" v-model="childInfo.residueCount" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="价格:">
            <el-input-number style="width: 270px" v-model="childInfo.expCardPay" placeholder=""></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="版本:" prop="userPhone">
            <el-select v-model="CardType" placeholder="请选择" style="width: 270px" @change="changeLessonIdC">
              <el-option v-for="item in [
                { label: 'A', value: 2 },
                { label: 'B', value: 1 },
              ]" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="选择体验卡:">
            <el-select style="width: 270px" v-model="childInfo.expCardId" placeholder="请选择">
              <el-option v-for="item in storeLessonExpCards" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <template v-if="CardType == 1">
        <el-row v-for="(v, index) in childInfo.userBuyLevels" :key="index">
          <el-col :span="12">
            <el-form-item label="业务等级:">
              <el-select v-model="v.lessonsId" placeholder="请选择" style="width: 270px">
                <el-option v-for="item in storeLessonsList" :disabled="childInfo.userBuyLevels
                  .map((mk) => {
                    return Number(mk.lessonsId);
                  })
                  .includes(item.storeLessonId)
                  ? true
                  : false
                  " :key="item.storeLessonId" :label="item.name" :value="item.storeLessonId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="display: flex;align-items: center;">
            <el-form-item label="确认等级:">
              <el-select v-model="v.level" placeholder="请选择" style="width: 150px">
                <el-option v-for="item in levelOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <i class="el-icon-circle-plus" v-if="childInfo.userBuyLevels.length - 1 == index"
              style="font-size: 25px; margin-left: 15px;cursor: pointer;color: #409eff;  margin-bottom: 22px;"
              @click="clickAdd"></i>
            <i v-else class="el-icon-remove" @click="clickDele(index)" style=" 
                  font-size: 25px;
                  cursor: pointer;
                  margin-left: 15px;
                  color: #409eff;
                  margin-bottom: 22px;
                "></i>
          </el-col>
        </el-row>
      </template>
      <el-row>
        <el-col :span="10">
          <el-form-item label="已购买体验卡:">
            <el-input v-model="cardNameLis" placeholder="" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="备注:">
        <el-input v-model="childInfo.remark" type="textarea" :autosize="{ minRows: 4 }" placeholder="请输入内容"
          style="width: 740px"></el-input>
      </el-form-item>
      <el-form-item label="语音备注:">
        <div style="width: 740px;display: flex;align-items: center;">
          <soundRecording ref="soundRecord" @clickRecStop="clickRecStop" @clickRecClear="clickRecClear" />
          <div v-if="audio" style="margin-left: 20px;">
            <audio controls ref="audio" class="aud" controlsList="nodownload noplaybackrate">
              <source :src="audio" />
            </audio>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer-1">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleUpdate()">确认</el-button>
    </div>
    <worker-word :key="refreshWord" :word-type="wordType" :t-data="tData" :show="showWordDlg"
      @onWorkerWord="handleWord"></worker-word>
  </div>
</template>
<style></style>

<script>
import commonUtils from "../../../utils/commonUtils";
import { selectChild, updateChildInfo } from "../../../api/userChild";
import messageUtils from "../../../utils/messageUtils";
import globaldata from "../../../utils/globaldata";
import WorkerWord from "../../../components/WorkerWord/WorkerWord";
import { changeUserExpCard, newUserByExpCard } from "../../../api/userByCard";
import soundRecording from "@/components/soundRecording";
import { selectCards, findCardByUserId } from "@/api/storeFront";
import { qlLessonTemplate } from "@/api/StoreLesson";
import enumsUtil, {
  EAllLevelOptions
} from "../../../utils/enumsUtil";
export default {
  name: "UserChangeExpCard",
  components: { WorkerWord, soundRecording },
  props: {
    childInfo: Object,
    childId: Number,

    // storeLessonExpCards: Array,
  },
  data() {
    return {
      rules: {},
      param: {
        expCardPay: 0,
      },
      showWordDlg: false,
      refreshWord: "",
      wordType: "",
      tData: "",
      genderOptions: [
        {
          value: 0,
          label: "男",
        },
        {
          value: 1,
          label: "女",
        },
      ],
      audio: '',
      storeLessonExpCards: [],
      levelOptions: EAllLevelOptions(),
      storeLessonsList: [],
      cardNameLis: '',

    };
  },
  mounted() { },
  created() {
    // this.initParam();
    this.getInitParam()
    this.getStoreLessList()
    this.findCardBy()
    this.getStoreLessList()
    console.log(this.childInfo, '11111111userBuyLevels=====')
  },
  methods: {
    getStoreLessList() {
      qlLessonTemplate({
        lessonId: 1,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
      }).then((res) => {
        if (res.code == 20000) {
          this.storeLessonsList = res.data
        }
      })
    },
    findCardBy() {
      findCardByUserId({
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        userId: this.childInfo.userId,
      }).then((res) => {
        if (res.code == 20000) {
          res.data.forEach(element => {
            this.cardNameLis = this.cardNameLis ? this.cardNameLis + ',' + element.cardName : element.cardName
          });

        }
        console.log('this.cardNameLis===')

      })
    },
    getStoreLessList() {
      qlLessonTemplate({
        lessonId: 1,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
      }).then((res) => {
        if (res.code == 20000) {
          this.storeLessonsList = res.data
        }
      })
    },
    clickRecStop(audio) {
      if (audio == 1) {
        this.$refs.soundRecord.recStop()
        let timer = setInterval(() => {
          this.audio = this.$refs.soundRecord.audio
          this.$refs.audio.src = this.audio
          this.$refs.soundRecord.dialogVisible = false
          // console.log(this.$refs.soundRecord.audio, 'refs.soundRecord.audio')
          clearInterval(timer)
        }, 500)
      } else {
        let timer = setInterval(() => {
          this.audio = this.$refs.soundRecord.audio
          this.$refs.audio.src = this.audio
          this.$refs.soundRecord.dialogVisible = false
          // console.log(this.$refs.soundRecord.audio, 'refs.soundRecord.audio')
          clearInterval(timer)
        }, 500)
      }
    },
    clickRecClear() {
      this.audio = ''
    },
    handleCancel() {
      this.$emit("onBtnCancel");
    },
    // 初始化参数
    getInitParam() {
      let param = {
        id: this.childId,
      };

      selectChild(param).then((response) => {
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }
        // this.param = {
        //   name: data.name,
        //   petName: data.petName,
        //   birthday: data.birthday,
        //   gender: data.gender,
        // };
        this.childInfo = {
          ...this.childInfo,
          userBuyLevels: data.userBuyLevels && data.userBuyLevels.length ? data.userBuyLevels : [{
            lessonsId: '',
            level: '',
          }]
        };
        console.log(this.childInfo, 'userBuyLevels=====')
        this.audio = this.childInfo.recording
        this.$refs.soundRecord.audio = this.childInfo.recording
        this.$refs.soundRecord.localUrl = this.childInfo.recording
      });
    },
    // 初始化参数
    initParam() {
      this.param.expCardPay = 0;
      this.$nextTick(() => {
        this.audio = this.childInfo.recording
        this.$refs.soundRecord.audio = this.childInfo.recording
        this.$refs.soundRecord.localUrl = this.childInfo.recording
        console.log(this.$refs, this.childInfo, 'this.$refs.soundRecord========')
      })
    },

    changeLessonIdC(e) {
      console.log("changeLessonIdC", e);
      if (e) {
        this.getStoreLessonCard(e);
      } else {
        this.$set(this.childInfo, "expCardId", null);
        this.storeLessonExpCards = [];
      }
    },
    async getStoreLessonCard(lessonId) {
      let self = this;
      const response = await selectCards({
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        statu: 0,
        exp: 1,
        lessonId,
      });
      if (response.code === 20000) {
        self.storeLessonExpCards = response.data;
      }
    },

    handleUpdate() {
      let userBuyLevels
      for (let index = this.childInfo.userBuyLevels.length; index > 0; index--) {
        if (this.childInfo.userBuyLevels[index - 1].lessonsId == '') {
          this.$delete(this.childInfo.userBuyLevels, index-1)
        }
      }
      if(this.childInfo.userBuyLevels && this.childInfo.userBuyLevels.length){
        userBuyLevels = this.childInfo.userBuyLevels
      }else{
        userBuyLevels = null
      }
      let param = {
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        userId: this.childInfo.userId,
        expCardId: this.childInfo.expCardId,
        userChildId: this.childInfo.userChildId,
        audio: this.audio,
        userBuyLevels:userBuyLevels
      };
      this.doRefreshWord(true, 1, param);
    },

    doBuyExpCard(param) {
      // console.log(param,  '-=================')
      // return
      changeUserExpCard(param).then((response) => {
        console.log(param,  '-=================')
        this.closeWordDlg();
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          messageUtils.errorMsg(this, response.message);
          return;
        }
        messageUtils.successMsg(this, response.message);
        this.$emit("handleChange");
      });
    },

    handleWord(wordType, tData) {
      if (wordType == 1) {
        this.doBuyExpCard(tData);
      }
    },

    doRefreshWord(show, wordType, tData) {
      this.tData = tData;
      this.wordType = wordType;

      this.showWordDlg = show;
      this.refreshWord = new Date().getTime();
    },
    closeWordDlg() {
      this.wordTitle = "";
      this.wordType = 0;
      this.showWordDlg = false;
      this.refreshWord = new Date().getTime();
    },
    clickAdd() {
      this.childInfo.userBuyLevels.push({
        lessonsId: '',
        level: '',
      })
    },
    clickDele(ind) {
      this.$delete(this.childInfo.userBuyLevels, ind)
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-input.is-disabled .el-input__inner {
  background: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/views/user_child/components/UserChangeExpCard.vue